import { observable, action, runInAction } from 'mobx';

import { CombatType } from '../lib/types';

import heroStore from './hero';
import appStore from './app';

import { getCombat, onCombatChanged } from '../lib/dbCalls';

import { timeout as timeoutService, attack as attackService } from '../lib/apiCalls';
import { mapCombat } from '../utils/combatUtils';

export async function timeout() {
  await timeoutService();
}

export async function attack(warriorId: string, strikes: number[], blocks: number[]) {
  await attackService(warriorId, strikes, blocks);
}

class Combat {
  @observable
  combat!: CombatType;

  @observable
  fetching: boolean = false;

  combatChangedRef: any = null;

  @action
  async fetch(id?: string) {
    this.fetching = true;
    const combat = await getCombat(id || this.combat.id, heroStore.hero, appStore.initData);
    runInAction(() => {
      if (id) {
        this.combat = combat;
      } else {
        Object.assign(this.combat, combat);
      }
      this.fetching = false;
    });
    if (id) {
      this.listenChanges();
    }
  }

  listenChanges() {
    this.combatChangedRef = onCombatChanged(this.combat.id, this.onCombatChanged);
  }

  onCombatChanged = async (snapshot: any) => {
    const value = snapshot.val();
    value.warriors.forEach((item: any, index: number) => {
      if (!item._warrior) {
        item._warrior = this.combat.warriors[index]._warrior;
      }
    });
    const newCombat = await mapCombat(value, null, appStore.initData);

    runInAction(() => {
      Object.assign(this.combat, newCombat);
    });
  };

  @action
  clear() {
    this.combatChangedRef.off('value', this.onCombatChanged);

    this.combat = null as any;
  }
}

export default new Combat();
